import {
  call,
  CallEffect,
  delay,
  put,
  race,
  RaceEffect,
  take,
  TakeEffect,
} from "redux-saga/effects";
import { userActivityStop } from "../../redux/userActivity/actions";

import { AxiosCustom } from "../../service/Axios";
import { USER_ACTIVITY } from "../../redux/userActivity/types";

export function* sendUserActivityWatcher(): Generator<
  TakeEffect | RaceEffect<TakeEffect | CallEffect<void>>,
  void,
  unknown
> {
  while (true) {
    yield take(USER_ACTIVITY.START);
    yield race([call(sendUserActivitySaga), take(USER_ACTIVITY.STOP)]);
  }
}

function* sendUserActivitySaga() {
  while (true) {
    try {
      yield call(() => AxiosCustom.sendActivity());
      console.log("ACTIVITY OK");
      yield delay(240000);
    } catch (e) {
      console.log("ACTIVITY FALSE");
      yield put(userActivityStop());
    }
  }
}
